/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import StepNav from 'material/embeds/steps/stepnav/stepnav_container';
import EmbedUpdateCTA from 'material/embeds/embedupdatecta/embedupdatecta_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/flowcontrols/flowcontrols_styles';


/* ========== ~~~~~~~~~~ FLOW CONTROLS : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const FlowControls = (props) => props.isNewEmbedFlow ?
    <StepNav handleSaveEmbed={props.handleSaveEmbed} /> :
    <EmbedUpdateCTA handleSaveEmbed={props.handleSaveEmbed} />;



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(FlowControls);
